(function(global) {
  "use strict";

  function toNumber(value) {
    if (value === null || value === undefined || value === "") return null;
    var parsed = Number(String(value).trim().replace(",", "."));
    return Number.isFinite(parsed) ? parsed : null;
  }

  function normalizeWidths(value) {
    var raw = Array.isArray(value) ? value : [value];
    var seen = {};
    return raw.map(toNumber).filter(function(width) {
      if (!width || width <= 0 || seen[String(width)]) return false;
      seen[String(width)] = true;
      return true;
    }).sort(function(a, b) { return a - b; });
  }

  function resolveWidths(input) {
    var variantWidths = normalizeWidths(input && input.variantWidths || []);
    var productWidths = normalizeWidths(input && input.productWidths || []);
    if (variantWidths.length) return { widths: variantWidths, source: "verified_variant_data" };
    if (productWidths.length) return { widths: productWidths, source: "verified_product_data" };
    if (String(input && input.family || "").toLowerCase() === "carpet") {
      return { widths: [4], source: "approved_carpet_default_4m" };
    }
    return { widths: [], source: "missing_verified_width" };
  }

  function normalizeSalesUnit(value) {
    return String(value || "").trim().toLowerCase().replace(/[\s-]+/g, "_");
  }

  function quantityModel(input) {
    var cutLength = toNumber(input && input.cutLength);
    var rollWidth = toNumber(input && input.rollWidth);
    if (!cutLength || cutLength <= 0 || !rollWidth || rollWidth <= 0) {
      return { state: "invalid_quantity", canApply: false };
    }
    var family = normalizeSalesUnit(input && input.family);
    var salesUnit = normalizeSalesUnit(input && input.salesUnit);
    var suppliedArea = Math.round((cutLength * rollWidth + Number.EPSILON) * 100) / 100;
    if (family === "carpet" || family === "sheet_vinyl") {
      var cartQuantity = Math.ceil(suppliedArea - 0.000001);
      var priceCents = Math.max(0, Math.round(toNumber(input && input.priceCents) || 0));
      return {
        state: "ok",
        cutLength: cutLength,
        rollWidth: rollWidth,
        suppliedArea: suppliedArea,
        displayText: suppliedArea.toFixed(2) + "m²",
        canApply: true,
        cartQuantity: cartQuantity,
        estimatedPriceCents: priceCents > 0 ? priceCents * cartQuantity : null,
        reason: "approved_roll_goods_square_metre_quantity"
      };
    }
    var canApply = salesUnit === "linear_metre" || salesUnit === "linear_meter" || salesUnit === "lm";
    return {
      state: "ok",
      cutLength: cutLength,
      rollWidth: rollWidth,
      suppliedArea: suppliedArea,
      displayText: "Quantity - " + formatNumber(cutLength) + "m x " + formatNumber(rollWidth) + "m Cut Length",
      canApply: canApply,
      cartQuantity: canApply ? Math.round((cutLength + Number.EPSILON) * 100) / 100 : null,
      reason: canApply ? "confirmed_linear_metre_unit" : "unconfirmed_cart_unit"
    };
  }

  function formatNumber(value) {
    return String(Math.round((value + Number.EPSILON) * 100) / 100);
  }

  var api = { resolveWidths: resolveWidths, quantityModel: quantityModel };
  global.ArraRollProductUnitEngine = api;
  if (typeof global.dispatchEvent === "function" && typeof global.Event === "function") {
    global.dispatchEvent(new global.Event("af:roll-product-unit-engine-ready"));
  }
  if (typeof module !== "undefined" && module.exports) module.exports = api;
})(typeof window !== "undefined" ? window : globalThis);
